import React from "react";
import bs from "../../../resources/bookshelf.png"

const Products = () => {
    return (
        <div className="w-60 h-60 overflow-hidden rounded-xl bg-emerald-300 hover:bg-emerald-500">
            <div className="h-2/3 overflow-hidden">
                <img src={bs}></img>
            </div>
            <div className="text-2xl text-white">Rubber Ducky</div>
        </div>
    )
}

export default Products;